// src/redux/archerChat/saga.js

import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchSSE } from '../../helpers/fetchSSE';
import {
  archerMessageSuccess,
  archerMessageFailure,
  archerTextDelta,
  archerSetConversationId,
  archerSetData,
  archerToolActive,
} from './actions';
import { ARCHER_SEND_MESSAGE } from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

function* sendMessageSaga({ payload: { message, conversationId, pageContext } }) {

  // Collect dispatches from the SSE stream via callback.
  // fetchSSE is a Promise so it works cleanly with redux-saga call().
  // onEvent fires synchronously per event during the pump() loop.

  const dispatches = [];
  let accText = '';

  const onEvent = (event) => {
    switch (event.type) {

      case 'CUSTOM':
        if (event.name === 'archer.conversationId') {
          dispatches.push(archerSetConversationId(event.value));
        }
        if (event.name === 'archer.data') {
          dispatches.push(archerSetData(event.value));
        }
        break;

      case 'TEXT_MESSAGE_CONTENT':
        accText += event.delta;
        dispatches.push(archerTextDelta(accText));
        break;

      case 'TOOL_CALL_START':
        dispatches.push(archerToolActive(event.toolName));
        break;

      case 'RUN_ERROR':
        dispatches.push(
          archerMessageFailure(event.message || 'An unknown error occurred')
        );
        break;

      default:
        break;
    }
  };

  try {
    yield call(
      fetchSSE,
      `${SERVER_URL}/Chat/SendMessage`,
      { message, conversationId, pageContext },
      onEvent
    );

    // Flush all queued dispatches in arrival order
    for (const action of dispatches) {
      yield put(action);
    }

    // Fire success only if no error was queued during the stream
    const hasError = dispatches.some(
      (a) => a.type === 'ARCHER_MESSAGE_FAILURE'
    );
    if (!hasError) {
      yield put(archerMessageSuccess({ reply: accText }));
    }

  } catch (error) {
    let msg = 'An unknown error occurred';
    if (error.status) {
      switch (error.status) {
        case 429: msg = 'AI service busy — please try again in a moment'; break;
        case 401: msg = error.description || 'Invalid credentials'; break;
        case 500: msg = 'Internal Server Error'; break;
        default:  msg = error.description || msg;
      }
    } else if (error.description) {
      msg = error.description;
    }
    yield put(archerMessageFailure(msg));
  }
}

function* watchSendMessage() {
  yield takeEvery(ARCHER_SEND_MESSAGE, sendMessageSaga);
}

function* ArcherChatSaga() {
  yield all([fork(watchSendMessage)]);
}

export default ArcherChatSaga;
